module.exports = __webpack_public_path__ + "Karma Pocket-f071d52a.png";